import { render, staticRenderFns } from "./tablepingjia.vue?vue&type=template&id=14ceb5bc&scoped=true"
import script from "./tablepingjia.vue?vue&type=script&lang=js"
export * from "./tablepingjia.vue?vue&type=script&lang=js"
import style0 from "./tablepingjia.vue?vue&type=style&index=0&id=14ceb5bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ceb5bc",
  null
  
)

export default component.exports